module.exports = __webpack_public_path__ + "img/1.10329578.jpg";